import Designers from '@components/shared/Designers/Designers';
import FAQ, { IFaqItem } from '@components/shared/FAQ/FAQ';
import LocationPageHero from '@components/shared/LocationPageHero/LocationPageHero';
import { useTheme } from '@components/theme';
import { Designer } from '@graphql/Designer/queries/availableDesigners.graphql';
import classNames from 'classnames';
import React from 'react';
import LocationsSubNavigation from '../LocationsSubNavigation/LocationsSubNavigation';

import styles from './Team.module.scss';

interface ITeamProps {
  faqItems: IFaqItem[];
  market: string;
  designers: Designer[];
}

const Team = ({
  faqItems, market, designers
}: ITeamProps) => {
  const theme = useTheme();

  return (
    <div className={theme.styles.Body}>
      <LocationsSubNavigation market={market} />
      <LocationPageHero
        backgroundColor={theme.styles.tint2}
        overlineText={'Our Team'}
        title={`Havenly's Top Interior Designers in ${market}`}
        smallImage="https://s3.us-east-1.amazonaws.com/static.havenly.com/prod/assets/team_page_small.jpeg"
        mainImage="https://s3.us-east-1.amazonaws.com/static.havenly.com/prod/assets/team_page_big.jpeg"
      />

      <div className={styles.DesignersWrapper}>
        <h2 className={classNames(styles.Title)}>
          {`Hire the perfect interior designer for your home`}
        </h2>
        <Designers
          designers={designers}
          displayAllDesignersLink
        />
      </div>

      <FAQ faq_items={faqItems} />

    </div>
  );
};

export default Team;
